
// region JS Imports

// region External Modules
import u from "umbrellajs"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
import {
  init as initWithToggle,
} from "apps/spacious_website/components/coliving_spaces/pictures_and_map_browser/with_toggle"
import Report_btn from "concepts/listings/problems/reports/new_report/button/index"
// endregion Public Components

// region Private Components
import {
  initAllMatchingElements as ColivingSpaceEntriesShortlistButton_init,
} from "apps/spacious_website/components/coliving_spaces/shortlist_button/icon_only"

// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--coliving-spaces--entry-box"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const IMAGE_CELL_CLASS_NAME = "cell--coliving-spaces--entry-box__image"

const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    const $el = u(el)

    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    $el.on("click", (e) => {
      const $this = u(e.target as HTMLElement)

      // If user clicks on a non-link, go to full listing page
      if ($this.closest(`.${IMAGE_CELL_CLASS_NAME}`).length === 0 && $this.closest("a").length === 0){
        window.open($el.data("coliving-space-page-path"), "_blank")
      }
    })
  })

  ColivingSpaceEntriesShortlistButton_init()
  initWithToggle()
  Report_btn.init()
}


export {
  init,
}
export default {init}
